import type { AnalyticsEvent } from '@cosuno/analytics-frontend';

export interface StoredAnalyticsEvent {
  name: 'identify' | 'pageView' | AnalyticsEvent | string;
  props: Record<string, unknown>;
}

export const storeEventForCypress = (event: StoredAnalyticsEvent) => {
  const analyticsEventsRaw = sessionStorage.getItem('analyticsEvents');
  const analyticsEvents: Array<StoredAnalyticsEvent> = analyticsEventsRaw
    ? JSON.parse(analyticsEventsRaw)
    : [];
  analyticsEvents.push(event);
  sessionStorage.setItem('analyticsEvents', JSON.stringify(analyticsEvents));
};
